<template>
  <div class="AtlasSummaryHeader">
    <template v-if="indicatorConfig">
      <indicator-summary
        :indicator-config="indicatorConfig"
        :geo-type="geoType"
        :geo-name="geoName"
      />
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import IndicatorSummary from './index.vue';

export default {
  name: 'atlas-indicator-summary-standalone',

  emits: [],

  components: {
    IndicatorSummary,
  },

  props: {
    indicatorId: {
      type: String,
      required: true,
    },

    defaultGeoCode: {
      type: String,
      default: null,
    },
  },

  data: () => ({
    geoTypeOptions: null,
    geoOption: null,
  }),

  watch: {
    indicatorId: {
      immediate: true,
      handler(id) {
        this.fetchIndicator({ id });
      },
    },
  },

  computed: {
    ...mapGetters('indicator', [
      'indicatorConfig',
      'geoSections',
      'activeGeoType',
      'activeGeoCode',
      'geoCodesByGeoGroup',
    ]),

    geoType() {
      const geoTypeConfig = this.geoSections.find(
        (section) =>
          section.id === this.activeGeoCode ||
          (section.children &&
            section.children.map((geo) => geo.id).includes(this.activeGeoCode)),
      );

      return geoTypeConfig?.text;
    },
    geoName() {
      const geoCodesMap = this.geoCodesByGeoGroup(this.geoType);

      const geoName = geoCodesMap ? geoCodesMap[this.activeGeoCode] : '';

      return geoName;
    },
  },

  methods: {
    ...mapActions('indicator', ['fetchIndicator']),
  },
};
</script>

<style lang="scss">
.AtlasSummaryHeader {
  &-picker {
    margin-bottom: 60px;
  }
}
</style>
